export default __webpack_public_path__ + "b93e0662839cd74266093f1b29ce5da6.png";